import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { WebsiteRoutingModule } from "./website-routing.module";
import { HomeComponent } from "./home/home.component";
import { WorkComponent } from "./work/work.component";
import { ContactComponent } from "./contact/contact.component";
import {
  InputTextModule,
  ChipsModule,
  KeyFilterModule,
  InputTextareaModule,
  InputMaskModule,
  ButtonModule,
  ContextMenuModule,
  MessageModule,
  CardModule
} from 'primeng/primeng';
import { MessageService } from 'primeng/api';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import {GalleriaModule} from 'primeng/galleria';
import { BlogComponent } from './blog/blog.component';
import { GifWeirdnessArticleComponent } from './work/articles/gif-weirdness-article/gif-weirdness-article.component';
import { SpaceGameArticleComponent } from './work/articles/space-game-article/space-game-article.component';
import { MyFeutArticleComponent } from './work/articles/my-feut-article/my-feut-article.component';
import { CarRentalArticleComponent } from './work/articles/car-rental-article/car-rental-article.component';
import { AbstractFactoryPostComponent } from './blog/posts/abstract-factory-post/abstract-factory-post.component';
import { BuilderPostComponent } from './blog/posts/builder-post/builder-post.component';
import { VisitorPostComponent } from './blog/posts/visitor-post/visitor-post.component';

@NgModule({
  declarations: [
    BlogComponent,
    HomeComponent,
    WorkComponent,
    ContactComponent,
    GifWeirdnessArticleComponent,
    SpaceGameArticleComponent,
    MyFeutArticleComponent,
    CarRentalArticleComponent,
    AbstractFactoryPostComponent,
    BuilderPostComponent,
    VisitorPostComponent
  ],
  imports: [
    CommonModule,
    WebsiteRoutingModule,
    InputTextModule,
    ChipsModule,
    KeyFilterModule,
    InputTextareaModule,
    InputMaskModule,
    ButtonModule,
    ReactiveFormsModule,
    ContextMenuModule,
    HttpClientModule,
    MessageModule,
    GalleriaModule,
    CardModule
  ], providers: [
    MessageService
  ]
})
export class WebsiteModule {}
